import { Col, Divider, Row } from "antd";
import { useState } from "react";
import { MdMyLocation } from "react-icons/md";
import { RiEdit2Line, RiHomeSmile2Fill } from "react-icons/ri";
import { BsFillPersonFill } from "react-icons/bs";
import { IoMdRadioButtonOn } from "react-icons/io";
import { RiCheckboxBlankCircleLine } from "react-icons/ri";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { Get } from "../../config/api/get";
import { RIDE, UPLOADS_URL } from "../../config/constants/api";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Post } from "../../config/api/post";
import { ImageUrl } from "../../config/helper";
import { FaShoppingBag } from "react-icons/fa";

const RideComponentRecent = ({
  pickupLocation,
  dropoffLocation,
  selectedTiming,
  setSelectedTiming,
  servicesRates,
}) => {
  const userData = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [startFocused, setStartFocused] = useState(false);
  const [destinationFocused, setDestinationFocused] = useState(false);
  const CustomCarDetails = ({
    heading,
    subheading,
    number,
    people,
    image,
    text,
    index,
  }) => {
    return (
      <div
        className={`py-4 px-2 justify-between flex items-center w-full ${
          selectedTiming === index ? "bg-[#F6DDB5]" : "bg-white"
        } gap-5`}
        onClick={() => {
          setSelectedTiming(index);
        }}
      >
        <div className="flex justify-center items-center cursor-pointer ">
          {selectedTiming === index ? (
            <IoMdRadioButtonOn size={24} className="text-[#E28C06] mr-4" />
          ) : (
            <RiCheckboxBlankCircleLine
              size={24}
              className="text-customBlack mr-4"
            />
          )}
          {/* <img
            src={ImageUrl(image)}
            alt="car"
            style={{
              maxHeight: "100px",
              maxWidth: "150px",
              objectFit: "cover",
              objectPosition: "center",
            }}
          /> */}

          <div className="flex flex-col items-start justify-center ml-2 ">
            <h5 className="capitalize font-euclid font-bold text-lg max-sm:text-xs text-customBlack">
              {heading}
            </h5>
            <div className="flex justify-center">
              <BsFillPersonFill
                size={15}
                className="text-customLightGray ml-2 mt-[2px]"
              />
              <p className="font-euclid text-xs max-sm:text-[10px] text-customLightGray font-bold mt-[2px]">
                {people}
              </p>
              {/* <FaShoppingBag
                size={15}
                className="text-customLightGray ml-2 mt-[2px]"
              />
              <p className="font-euclid text-xs max-sm:text-[10px] text-customLightGray font-bold mt-[2px]">
                {people}
              </p> */}
            </div>

            <p className="capitalize font-euclid font-bold text-xs max-sm:text-[10px] text-customLightGray">
              {subheading}
            </p>
            <p className="capitalize font-euclid font-bold text-xs max-sm:text-[10px] text-customLightGray">
              {text}
            </p>
          </div>
        </div>
        <p className="ml-2 font-euclid font-bold text-lg max-sm:text-sm text-customBlack">
          ${number.toFixed(2)}
        </p>
        {/* <div className="flex flex-col"> */}
        {/* <p className="capitalize font-euclid font-bold text-[10px] text-customBlack">
            {time}
          </p> */}
        {/* </div> */}
      </div>
    );
  };

  return (
    <Row justify="center">
      <Col xs={24}>
        <div className="border border-gray-300 py-8 px-4 flex flex-col justify-start items-start sm:pb-64">
          {/* <h5 className="font-tavi text-3xl text-black mb-4">Get a Ride</h5> */}
          <h5 className="font-tavi text-3xl text-black mb-4">
            Get Your Reservation
          </h5>
          <div className="flex flex-col items-center justify-center w-full">
            <div className="flex justify-start items-center rounded-sm border border-gray-300 bg-white p-3 w-full">
              <MdMyLocation
                size={24}
                className={
                  startFocused
                    ? "text-customGold transition-colors"
                    : "text-red-600 transition-colors"
                }
              />
              <div className="flex flex-col items-start justify-center ml-2 w-full">
                <p
                  className={`font-euclid text-sm max-sm:text-xs ${
                    startFocused ? "text-customGold" : "text-customBlack "
                  } font-bold transition-colors`}
                >
                  Start
                </p>
                <p
                  className={`font-euclid text-sm max-sm:text-xs ${
                    startFocused ? "text-customGold" : "text-[#666] "
                  } font-bold transition-colors`}
                >
                  {pickupLocation?.address}
                </p>
              </div>
            </div>
            <div className="flex justify-start items-center rounded-sm border border-gray-300 bg-white p-3 w-full">
              <MdMyLocation
                size={24}
                className={
                  destinationFocused
                    ? "text-customGold transition-colors"
                    : "text-red-600 transition-colors"
                }
              />
              <div className="flex flex-col items-start justify-center ml-2 w-full">
                <p
                  className={`font-euclid text-sm max-sm:text-xs ${
                    destinationFocused ? "text-customGold" : "text-customBlack "
                  } font-bold transition-colors`}
                >
                  Destination
                </p>
                <p
                  className={`font-euclid text-sm max-sm:text-xs ${
                    destinationFocused ? "text-customGold" : "text-[#666] "
                  } font-bold transition-colors`}
                >
                  {dropoffLocation?.address}
                </p>
              </div>
            </div>

            <Divider />

            <>
              <div className="my-8 flex flex-col items-center w-full">
                <h5 className="font-tavi text-3xl text-black mb-4 max-sm:text-lg ">
                  Pick a Service Type
                </h5>

                {/* <div className="flex flex-col w-full">
                  <CustomCarDetails
                    key={1}
                    heading="Black Luxury"
                    // subheading="sjsd"
                    index={1}
                    number={servicesRates?.black}
                    people="3"
                    image="demo-3.png"
                    driverId="shsh"
                  />
                  <CustomCarDetails
                    key={2}
                    heading="Ultra Luxury"
                    // subheading="sjsd"
                    index={2}
                    number={servicesRates?.ultra}
                    people="3"
                    image="demo-2.png"
                    driverId="shsh"
                  />
                  <CustomCarDetails
                    key={3}
                    heading="SUV Luxury"
                    // subheading="sjsd"
                    number={servicesRates?.suv}
                    index={3}
                    people="3"
                    image="demo-3.png"
                    driverId="shsh"
                  />
                  ))
                </div> */}
                <div className="flex flex-col w-full">
                  {servicesRates ? (
                    Object.entries(servicesRates).map(
                      ([serviceType, capacities], serviceIndex) =>
                        Object.entries(capacities || {}).map(
                          ([capacity, fare], capacityIndex) => (
                            <CustomCarDetails
                              key={`${serviceIndex}-${capacityIndex}`}
                              heading={`${serviceType} Luxury`} // Use the service type dynamically
                              number={fare || 0} // Fare for this capacity
                              people={`${capacity} Passengers`} // Show specific passenger capacity
                              image={`demo-${serviceIndex + 1}.png`} // Dynamically assign images
                              index={`${serviceIndex}-${capacityIndex}`} // Unique index for each item
                            />
                          )
                        )
                    )
                  ) : (
                    <p className="text-xl font-semibold mt-6 text-center">
                      No Nearby Cars found for this Category
                    </p>
                  )}
                </div>
              </div>
            </>
            {/* )} */}
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default RideComponentRecent;
